import { render, staticRenderFns } from "./ExtraStaffInfo.vue?vue&type=template&id=2232c4ac&scoped=true&"
import script from "./ExtraStaffInfo.vue?vue&type=script&lang=js&"
export * from "./ExtraStaffInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232c4ac",
  null
  
)

export default component.exports